<template>
  <div>
    <b-table
        v-bind="$props"
        v-on="$listeners"
        :current-page="currentPage"
        :filter="filter"
        :filter-function="filterFunction"
        @filtered="onFiltered"
    >
      <template v-for="slot in slots" #[slot.name]="scope">
        <slot v-if="slot.type === 'slot'" :name="slot.name" v-bind="scope"/>
        <searchable-label
            v-else-if="slot.type === 'sl'"
            :label="scope.label"
            v-model="filter[slot.key]"
            :key="slot.key"/>
        <searchable-label-list
            v-else-if="slot.type === 'sll'"
            :label="scope.label"
            :options="slot.options"
            v-model="filter[slot.key]"
            :key="slot.key"/>
      </template>
    </b-table>
    <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        align="center"/>
  </div>
</template>

<script>
import SearchableLabel from "./SearchableLabel";
import SearchableLabelList from "@/components/SearchableLabelList";
import {History} from "@/js/history";

export default {
  name      : "BPaginatedTable",
  components: {SearchableLabelList, SearchableLabel},
  props     : {
    //Usefull
    items     : Array,
    fields    : Array,
    busy      : Boolean,
    perPage   : {
      type: Number, default() {
        return 20;
      }
    },
    persistant: {
      type: Boolean
    },
    filter    : {
      type: Object,
      default() {
        return History.Persistence.Get()?.filter || {}
      }
    },
    // Register Props for other components
    "sort-by": String, "sort-desc": Boolean,
  },
  data() {
    return {
      currentPage: History.Persistence.Get()?.currentPage || 1,
      totalRows  : this.items.filter(row => this.filterFunction(row, this.filter)).length,
    }
  },
  computed: {
    slots() {
      return [
        ...Object.keys(this.$scopedSlots).map(key => {
          return {type: "slot", name: key}
        }),
        ...(this.$props.fields || [])
            .filter(f => f.filterable)
            .map(({key, filterable}) => {
              return {
                key,
                name   : `head(${key})`,
                type   : filterable.length ? "sll" : "sl",
                options: filterable
              }
            })
      ]
    },
  },
  methods : {
    filterFunction(row, filter) {
      const keys = Object.keys(filter);
      return keys.every(k => this.chooseFilter(filter[k], row[k]));
    },
    chooseFilter(filter, data) {
      switch (typeof filter) {
        case "string":
          return this.StringFilter(filter, data);
        case "object":
          return this.ListFilter(filter, data);
        default:
          console.warn("filter do not support", typeof filter);
          return true
      }
    },
    ListFilter(list, data) {
      return !list.length || list.includes(data);
    },
    StringFilter(search, data) {
      return data.toLowerCase().includes(search.toLowerCase());
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      if (this.totalRows < this.perPage) this.currentPage = 1;
      this.$emit('filtered', filteredItems);
    },
  },
  created() {
    if (this.persistant) {
      History.Persistence.Bind(this, "filter");
      History.Persistence.Bind(this, "currentPage");
    }
  },
}
</script>

<style>
.table thead th {
  vertical-align: baseline !important;
}
</style>